module.exports = __webpack_public_path__ + "static/media/ThreatX-logo-full-reversed.68f67886.svg";